import {
  AfterContentChecked,
  AfterContentInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  OnDestroy,
  QueryList,
} from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { delay, map, startWith } from 'rxjs/operators';
import { AllTableModifiersService } from '@prlw/core/monitor/all-table-modifiers.service';
import { AllTableTabItemComponent } from './all-table-tab-item.component';
import { ModifierType } from '@prlw/core/monitor/types/common';
import { isEqual } from 'lodash';

@Component({
  selector: 'prlw-all-table-tabs',
  templateUrl: './all-table-tabs.component.html',
  styleUrls: ['./all-table-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllTableTabsComponent
  implements AfterContentChecked, AfterContentInit, OnDestroy
{
  public activeTabLabel!: ModifierType | undefined;
  @ContentChildren(AllTableTabItemComponent)
  private readonly _tabs!: QueryList<AllTableTabItemComponent>;
  public tabItems$!: Observable<AllTableTabItemComponent[]>;
  public activeTab: AllTableTabItemComponent | null = null;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly allTableModifiersState: AllTableModifiersService,
  ) {
    this.allTableModifiersState.modifier$.subscribe((data) => {
      this.activeTabLabel = data.type;
    });
  }

  public ngAfterContentInit(): void {
    this.tabItems$ = this._tabs.changes.pipe(
      startWith(''),
      delay(0),
      map(() => this._tabs.toArray()),
    );

    this.allTableModifiersState.modifier$.subscribe((data) => {
      this.activeTabLabel = data.type;
    });

    this.tabItems$.subscribe((data) => {
      this.activeTab = data.find((tab) =>
        isEqual(tab.label, this.activeTabLabel),
      ) as AllTableTabItemComponent;
    });
  }

  public ngAfterContentChecked(): void {
    if (!this.activeTab) {
      this.activeTab = this._tabs.first;
      this.changeDetectorRef.detectChanges();
    }
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public selectTab(tabItem: AllTableTabItemComponent): void {
    if (this.activeTab !== tabItem && !tabItem.disabled) {
      this.activeTab = tabItem;
      this.activeTabLabel = this.activeTab.label;
      if (
        tabItem.label === ModifierType.BASIC ||
        tabItem.label === ModifierType.SIMPLE
      ) {
        this.allTableModifiersState.updateModifier({
          type: tabItem.label,
        });
        return;
      }
      if (tabItem.label === ModifierType.PREPAID) {
        this.allTableModifiersState.updateModifier({
          type: tabItem.label,
          data: {
            prepaidMargin: 0,
          },
        });
        return;
      }
      this.allTableModifiersState.updateModifier({
        type: tabItem.label,
        data: {
          deferPercent: 0,
          deferPeriod: 0,
        },
      });
    }
  }
}
